export class SalesGroup {
  name!: string;
  groupName!: string;

  constructor(name: string, parent = undefined) {
    this.name = name;
    this.groupName = parent;
  }

  public load(data: any): SalesGroup {

    Object.assign(this, data);

    return this;
  }
}
